export function userMarketNameAll(nftType?: string) {
  const marketTypeMap = {
    3: 'BSC Artists',
    111: 'BSC Artists',
    116: 'KAKA NFT',
    122: 'KAKA NFT',
    123: 'KAKA NFT',
    107: 'Radio Caca NFT',
    113: 'Radio Caca NFT',
    117: 'Radio Caca NFT',
    112: 'Tokau NFT',
    105: 'LoveNFT',
    101: 'SafeNFT',
    4: 'Musk&Doge',
    8: '1inch&BAKE',
    5: 'BAKE&Banana',
    1: 'BTC Artworks',
    6: 'Seascape',
    2: 'Binance NFT',
    7: 'TKO NFT',
    109: 'YooShi NFT',
    110: 'Bondly NFT',
    115: 'Alchemy Toys',
    104: 'Crypto Doggies',
    108: 'Barking NFT',
    114: 'Doggy Equipment',
    106: 'Poker NFT',
    103: 'Rare Car',
    10: 'Bakery Combos',
    100: 'BakerySoccer',
    13: 'Battle Pets',
    12: 'Weapons',
    11: 'Pet Eggs',
    119: 'Blin',
    121: 'Binamon',
    120: 'Ga'
  }
  return nftType ? marketTypeMap[nftType] : ''
}
